/* eslint-disable @typescript-eslint/no-explicit-any */

import styles from './vendorCard.module.css';

interface VendorCardDetailsProps {
  vendorList: any[];
}

interface VendorCardItemProps {
  vendor: string;
  rate: number;
  amount: string;
  available: boolean;
  brand: string;
  qty: number;
}

const VendorCardItem: React.FC<VendorCardItemProps> = ({
  amount,
  available,
  brand,
  qty,
  rate,
  vendor,
}) => {
  return (
    <div className={styles.vendorCardItem}>
      <div className={styles.vendorCardInfoType}>
        <span>Vendor</span>
        <span className={vendor?.length > 10 ? styles.textOverflow : ''}>
          {vendor}
        </span>
      </div>
      <div className={styles.vendorCardInfoType}>
        <span>Rate</span>
        <span>{rate}</span>
      </div>
      <div className={styles.vendorCardInfoType}>
        <span>Amount</span>
        <span>{amount}</span>
      </div>
      <div className={styles.vendorCardInfoType}>
        <span>Available</span>
        <span>{available ? 'Yes' : 'No'}</span>
      </div>
      <div className={styles.vendorCardInfoType}>
        <span>Brand</span>
        <span className={brand?.length > 10 ? styles.textOverflow : ''}>
          {brand}
        </span>
      </div>
      <div className={styles.vendorCardInfoType}>
        <span>Quantity</span>
        <span>{qty}</span>
      </div>
    </div>
  );
};

const VendorCardDetails: React.FC<VendorCardDetailsProps> = ({
  vendorList,
}) => {
  return (
    <div>
      {vendorList?.map(
        ({ id, amount, available, brand, name, vendorQty, rate }) => (
          <VendorCardItem
            key={`${id}${brand}`}
            amount={amount}
            available={available}
            brand={brand}
            qty={vendorQty}
            rate={rate}
            vendor={name}
          />
        )
      )}
    </div>
  );
};

export default VendorCardDetails;
